export default {
    cn: {
        commissionView: {
            title: '佣金设定',
            role: {
                ib: '代理佣金设定',
                sale: '销售佣金设定',
            }
        }
    },
    hk: {
        commissionView: {
            title: '佣金設定',
            role: {
                ib: '代理佣金設定',
                sale: '銷售佣金設定',
            }
        }
    },
    en: {
        commissionView: {
            title: 'Commission Setting',
            role: {
                ib: 'IB Commission Setting',
                sale: 'Sales Commission Setting',
            }
        }
    }
}


// WEBPACK FOOTER //
// ./src/MultiLanguage/CommissionSetting/commissionView.js